import Model from './Model'

export default class PromoType extends Model {
  resource() {
    return 'settings/promo-types'
  }
}
